import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
        cancelAnimationFrame(rafId);
        lenis.destroy();
        lenis = null;
    };
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -96, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}

export function scrollTop() {
    if (lenis) {
        lenis.scrollTo(0, { immediate: true });
    } else {
        window.scrollTo(0, 0);
    }
}
